import GiftCardViewSFC from "./GiftCardView.vue";
export const GiftCardView = GiftCardViewSFC;
